import IntervalController from "./interval_controller"

// Este es un intervalo para ásana. Tiene imágen y puede tener compensación
// cycle sería un lado. Full cycle sería ambos lados. (si hay compensación)
export default class extends IntervalController {

  static targets = [
    "compensation",
    "sideDuration",
  ]
  static values = {
    imageId: String,
    strLeft: String,
    strRight: String,
  }

  connect() {
    super.connect()
    this.renderDuration()
    if (this.hasImageIdValue) {
      this.imageElement = document.getElementById(this.imageIdValue)
    }
  }

  start(){
    super.start()
  }

  continue(){
    super.continue()
  }

  finish(){
    this.hideImage()
    super.finish()
  }

  showImage(){
    if (this.imageElement){
      this.show(this.imageElement)

      if (this.hasCompensation() && this.isLastCycle()) {
        this.imageElement.classList.add("mirror-x")
      } else {
        this.imageElement.classList.remove("mirror-x")
      }
    }
  }

  hideImage(){
    if (this.imageElement){
      this.hide(this.imageElement)
    }
  }

  initClicks(){
    super.initClicks()
    this._cycleClick = 0
    this._currentCycle = 0 // left/right
  }

  initDurations(){
    const minutes = parseInt(this.durationMinutesTarget.value) || 0
    const seconds = parseInt(this.durationSecondsTarget.value) || 0
    this._cycleDuration = minutes * 60 + seconds
    this._totalDuration = this.cyclesForFullCycle() * this._cycleDuration
    document.dispatchEvent(new CustomEvent("interval:durationChanged"))
  }
  
  incClick(){
    super.incClick()
    this._cycleClick = Math.floor(this.currentClick % this._cycleDuration)
    this._currentCycle = this.calculateCurrentCycle()
  }

  playNeededAudio(){
    if (this.isOverDuration()) {
      // sound played in timer player
    } else if (this.currentClick === 0 && this.timerPlayerOutlet.hasAudio("start")) {
      this.timerPlayerOutlet.playAudio("start")
    } else if (this.isFirstClickOfCycle() && !this.isFirstCycle()) {
      this.timerPlayerOutlet.playAudio("metronomeChange")
    } else if (this.playClickValue) {
      this.timerPlayerOutlet.playAudio("click")
    }
  }

  render(){
    super.render()

    // acá suele estar el reloj más grande.
    this.timerPlayerOutlet.clickMessageTarget.innerText = ""

    this.showImage()
  }

  // renders elapsedTime in CYCLE (left/right)
  renderElapsedTime() {
    let humanClick = this._cycleClick + 1
    let message = `${Math.floor(humanClick / 60)}:${(humanClick % 60).toString().padStart(2, '0')}`
    message += ` / ${Math.floor(this._cycleDuration / 60)}:${(this._cycleDuration % 60).toString().padStart(2, '0')}`
    this.timerPlayerOutlet.elapsedTimeMessageTarget.innerText = message
  }

  renderIntervalName() {
    super.renderIntervalName()
  }

  presentation() {
    return {...super.presentation(), type: "asana", elapsed: this._cycleClick + 1,
      duration: this._cycleDuration,
      side: this.hasCompensation() ? (this.isFirstCycle() ? this.strLeftValue : this.strRightValue) : ""}
  }

  calculateCurrentCycle(){
    return Math.floor(this.currentClick / this._cycleDuration)
  }

  cyclesForFullCycle(){
    if (this.hasCompensation()) {
      return 2
    } else {
      return 1
    }
  }

  isFirstClickOfCycle(){
    return this._cycleClick === 0
  }

  isLastClickOfCycle(){
    return this._cycleClick === this._cycleDuration - 1
  }

  isFirstCycle(){
    return this.calculateCurrentCycle() == 0
  }

  isLastCycle(){
    return  this.calculateCurrentCycle() == (this.cyclesForFullCycle() - 1)
  }

  actionMessage(){
    if (this.hasCompensation()){
      switch (this.calculateCurrentCycle()){
        case 0:
          return `${this.nameValue} ${this.strLeftValue}`
        case 1:
          return `${this.nameValue} ${this.strRightValue}`
      }
    } else {
      return this.nameValue
    }
  }

  nextActionMessage() {
    if (this.hasCompensation()){
      switch (this.calculateCurrentCycle() + 1){
        case 0:
          return `${this.nameValue} ${this.strLeftValue}`
        case 1:
          return `${this.nameValue} ${this.strRightValue}`
      }
    } else {
      return this.nameValue
    }
  }

  hasCompensation(){
    if (this.compensationTarget.type == "checkbox"){
      return this.compensationTarget.checked
    } else {
      return this.compensationTarget.value == "1"
    }
  }

  renderDuration(){
    super.renderDuration()
    if (this.hasSideDurationTarget) {
      this.sideDurationTarget.innerText = `${Math.floor(this._cycleDuration / 60)}:${(this._cycleDuration % 60).toString().padStart(2, '0')}`
    }
  }

  hasNextAction(){
    return !this.isLastCycle()
  }

}
